<template>
  <mdb-container class="gp-has-header">
    <div class="text-left">
      <div v-if="showMain">
        <h3>Integrations</h3>
        <mdb-btn size="sm" rounded @click="addIntegration" icon="plus-circle">Add Integration</mdb-btn>
        <div v-if="integrations.length>0">
          <mdb-tbl responsive striped>
            <mdb-tbl-head class="secondary-color text-white">
              <tr>
                <th>Type</th>
                <th>Enabled</th>
                <th></th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr :key="i" v-for="(integration,i) in integrations">
                <td>{{ integration.name }}</td>
                <td>
                  <mdb-icon icon="check" v-if="integration.enabled"/>
                </td>
                <td>
                  <mdb-btn @click="editIntegration(integration)" floating icon="pencil" size="sm" tag="a"/>
                  <mdb-btn @click="deleteIntegration(integration)" floating icon="trash" color="danger" size="sm"
                           tag="a"/>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </div>
        <div v-if="integrations.length==0">
          No integrations set up.
        </div>
      </div>

      <div v-if="showEdit">
        <mdb-card class="mb-4">
          <mdb-card-header>
            <h3>Edit Integration</h3>
          </mdb-card-header>
          <mdb-card-body>
            <mdb-btn size="sm" rounded icon="arrow-left" @click="cancelEditing">Back to List</mdb-btn>

            <gp-select :dataObj="editing" :possible-values="integrationTypes" :required="true"
                       label="Type" propertyName="type"/>

            <mdb-input label="API Access ID" type="text" v-model="editing.apiAccessId"/>
            <mdb-input label="API Secret Key" :type="extraConfig.textSecret ? 'textarea' : 'text'" v-model="editing.apiSecretKey"/>
            <mdb-input v-if="extraConfig.opt1" :label="extraConfig.opt1Label" type="text" v-model="editing.configOption1"/>
            <mdb-input v-if="extraConfig.opt2" :label="extraConfig.opt2Label" type="text" v-model="editing.configOption2"/>
            <mdb-input v-if="extraConfig.opt3" :label="extraConfig.opt3Label" type="text" v-model="editing.configOption3"/>
            <mdb-input v-if="extraConfig.opt4" :label="extraConfig.opt4Label" type="text" v-model="editing.configOption4"/>
            <mdb-input v-if="extraConfig.opt5" :label="extraConfig.opt5Label" type="text" v-model="editing.configOption5"/>
            <mdb-input type="checkbox" id="enabled" name="enabled" v-model="editing.enabled" label="Enabled"/>

            <mdb-btn @click="saveIntegration" color="success" icon="save">Save</mdb-btn>
            <mdb-btn @click="cancelEditing" color="danger" icon="times-circle">Cancel</mdb-btn>
          </mdb-card-body>
        </mdb-card>
      </div>

    </div>

    <yes-no-modal @yes="doDelete" @no="deleteModal=false" v-if="deleteModal"
                  additional-text="Are you sure you wish to delete this integration?"></yes-no-modal>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import gpSelect from "../common/GPSelect";
import YesNoModal from "../common/YesNoModal";


import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';


export default {
  name: "integrations",
  order: 1,
  components: {
    mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon, mdbBtn, mdbInput,
    mdbCard, mdbCardBody, mdbCardHeader,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    gpSelect,
    YesNoModal
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$storestate.settings
    },
    extraConfig() {
      let ret = {
        opt1: false,
        opt1Label: "",
        opt2: false,
        opt2Label: "",
        opt3: false,
        opt3Label: "",
        opt4: false,
        opt4Label: "",
        opt5: false,
        opt5Label: "",
        textSecret: false
      }
      if (this.editing && this.editing.type == "COGNITO_LOGIN") {
        ret.opt1 = true
        ret.opt1Label = "App Web Domain"
        ret.opt2 = true
        ret.opt2Label = "Client Pool ID"
        ret.opt3 = true
        ret.opt3Label = "AWS Region ID"
        ret.opt4 = true
        ret.opt4Label = "App Client ID"
        ret.opt5 = true
        ret.opt5Label = "App Client Secret"
        ret.textSecret = false
      }
      if (this.editing && this.editing.type == "JITSI") {
        ret.opt1 = true
        ret.opt1Label = "Application ID"
        ret.opt2 = true
        ret.opt2Label = "Site Id"
        ret.opt3 = true
        ret.opt3Label = "Audience ID"
        ret.opt4 = true
        ret.opt4Label = "Host Name"
        ret.opt5 = true
        ret.opt5Label = ""
        ret.textSecret = true
      }
      if (this.editing && this.editing.type == "DISCOURSE") {
        ret.opt1 = true
        ret.opt1Label = "Signature Secret"
        ret.opt2 = true
        ret.opt2Label = "Endpoint"
        ret.opt3 = true
        ret.opt3Label = "Menu Title"
        ret.opt4 = false
        ret.opt4Label = ""
        ret.opt5 = false
        ret.opt5Label = ""
        ret.textSecret = false
      }
      return ret
    }
  },

  data() {
    return {
      integrations: [],
      currentIntegration: null,
      editing: null,
      deleteCandidate: null,
      deleteModal: false,
      showDeleteModal: false,
      showMain: true,
      showEdit: false,
      integrationTypes: [],
    }
  },
  mounted() {
    document.title = "Integrations"
    this.$store.dispatch("setExecuting", true)
    api.get("/integration/list").then(
      (results) => {
        this.integrations = results.data.integrations
        this.integrationTypes = results.data.integrationTypes
        this.showMain = true
      },
      (error) => {
        if (error.response.status == 403 || error.response.status == 401) {
          this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
          return
        }
        this.$notify.error({message: error.response.data, timeOut: 20000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {

    saveIntegration() {
      this.$store.dispatch("setExecuting", true)
      api.post("/integration/save", this.editing).then(
        (results) => {
          if (this.editing.id) Object.assign(this.currentIntegration, results.data)
          else (this.integrations.push(results.data))
          this.$notify.success({message: "Success", timeOut: 2000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addIntegration() {
      this.editing = {
        id: null,
        type: null,
        apiAccessId: null,
        apiSecretKey: null,
        configOption1: null,
        configOption2: null,
        configOption3: null,
        enabled: true
      }
      this.showMain = false
      this.showEdit = true
    },
    deleteIntegration(integration) {
      this.deleteCandidate = integration
      this.deleteModal = true
    },
    doDelete() {
      this.deleteModal = false;
      this.$store.dispatch("setExecuting", true)
      api.delete("/integration/delete/" + this.deleteCandidate.id).then(
        (results) => {
          let loc = this.integrations.indexOf(this.deleteCandidate);
          this.deleteCandidate = null;
          if (loc >= 0) this.integrations.splice(loc, 1);
          this.$notify.success({message: "Success", timeOut: 2000})
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    editIntegration(integration) {
      this.currentIntegration = integration
      this.editing = JSON.parse(JSON.stringify(integration));
      this.showEdit = true
      this.showMain = false
    },
    cancelEditing() {
      this.currentIntegration = null
      this.editing = null
      this.showMain = true
      this.showEdit = false
    }

  }
};

</script>

